const DEFAULT_RETURN_TO = '/myCourses';

const cleanId = (value) => {
  if (value === undefined || value === null) return '';
  const id = String(value).trim();
  return id && id !== 'undefined' && id !== 'null' ? id : '';
};

export const getEducationExamId = (exam) => cleanId(
  exam?.primaryId
  ?? exam?.examPrimaryId
  ?? exam?.exam?.primaryId
  ?? exam?.academyExam?.primaryId
);

export const sanitizeEducationReturnTo = (value, fallback = DEFAULT_RETURN_TO) => {
  const candidate = String(value || '').trim();
  if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) return fallback;
  try {
    const parsed = new URL(candidate, 'https://education.local');
    if (parsed.origin !== 'https://education.local') return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
};

const searchParamsOf = (search = '') => new URLSearchParams(String(search || '').replace(/^\?/, ''));

export const resolveEducationExamRouteContext = ({ search = '', state, storage } = {}) => {
  const params = searchParamsOf(search);
  const stateExam = state?.exam || null;
  const queryExamId = cleanId(params.get('examId'));
  const stateExamId = getEducationExamId(stateExam);
  const storedExamId = cleanId(storage?.getItem?.('examPrimaryId'));
  const returnTo = sanitizeEducationReturnTo(
    params.get('returnTo') || state?.returnTo || state?.from,
    DEFAULT_RETURN_TO
  );

  return {
    exam: stateExam,
    examId: queryExamId || stateExamId || storedExamId,
    returnTo,
    source: queryExamId ? 'query' : stateExamId ? 'state' : storedExamId ? 'storage' : 'missing'
  };
};

const withExamContext = (pathname, { examId, returnTo } = {}) => {
  const params = new URLSearchParams();
  const resolvedExamId = cleanId(examId);
  if (resolvedExamId) params.set('examId', resolvedExamId);
  const safeReturnTo = sanitizeEducationReturnTo(returnTo, '');
  if (safeReturnTo) params.set('returnTo', safeReturnTo);
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
};

export const buildEducationSystemCheckPath = (context) => withExamContext('/exam/system-check', context);

export const buildEducationExamManagementPath = (context) => withExamContext('/exam-management', context);

export const buildEducationViolationPath = (context) => withExamContext('/exam/violation', context);

export const buildEducationGradePath = (courseName, examId) => (
  `/courseDetails/${encodeURIComponent(String(courseName || 'course'))}/grade/${encodeURIComponent(cleanId(examId))}`
);
